<template>
  <div class="relative">
    <DropZone
      :ref="name"
      :id="name"
      :options="options"
      @vdropzone-complete-multiple="fileSavingSuccessEvent"
      @vdropzone-error-multiple="fileSavingErrorEvent"
    />
    <button class="product-options__dropzone-save" @click="continueUpload">
      <fa-icon class="text-white" :icon="['fas', 'save']" size="xs" />
    </button>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    DropZone: vue2Dropzone
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    fileSavingSuccessEvent(response) {
      console.log(response)
    },
    fileSavingErrorEvent() {
      // files, data, xhr
      console.log('error')
      // if (xhr && data) {
      //  const errorOfModels = Object.entries(data.errors)
      //  const errors = errorOfModels.map((errorArray) => {
      //    return errorArray[0]
      //  })
      //  console.log(errors)
      // }
    },
    continueUpload() {
      this.$refs.productDropZone.processQueue()
    }
  }
}
</script>
